export default navigator.userAgent.includes('JustoServer')
